import React from 'react';
import { Calendar } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';

export default function NewsModal({ selectedNews, onClose, formatDate }) {
  if (!selectedNews) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="news-modal">
      <Card className="max-w-3xl w-full max-h-[90vh] overflow-y-auto border-0 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        {selectedNews.image_url && (
          <div className="relative h-64 overflow-hidden">
            <img src={selectedNews.image_url} alt={selectedNews.title} className="w-full h-full object-cover" />
          </div>
        )}
        <CardContent className="p-8">
          <div className="flex items-center gap-2 text-sm text-zinc-500 mb-4">
            <Calendar className="h-4 w-4 text-fuchsia-500" />
            <span>{formatDate(selectedNews.published_at)}</span>
          </div>
          <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold text-zinc-900 mb-6">{selectedNews.title}</h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-zinc-600 leading-relaxed whitespace-pre-wrap">{selectedNews.content}</p>
          </div>
          <Button className="mt-8 rounded-full" onClick={onClose} data-testid="close-modal-btn">Fermer</Button>
        </CardContent>
      </Card>
    </div>
  );
}
